import React from "react";

export default function QaProccess() {
  return (
    <section className="relative bg-[#292936] text-white py-[32rem] px-6 md:px-12 lg:px-20">
        <div
        className="absolute inset-0  "
        style={{
          backgroundImage:
            "url('/static/qaproccess.svg')", // put your repeated icons image here
          backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
        }}
      ></div>
        {/* Title */}
        <div className="text-left w-11/12 md:w-4/5 mx-auto relative z-0 top-64">
          <h2 className="!text-3xl md:!text-[45px] !font-bold !leading-[3.5rem]">
          Illuminating the QA Process: See Your Game Environment in a New Light
          </h2>
          <p className="mt-4 text-white !font-semibold md:!text-[25px] !text-base !leading-8">
          Instead of relying on vague bug reports and guesswork, QA teams now see the complete environmental context - every variable, every state change, every player interaction that led to an issue. This comprehensive visibility doesn't just speed up testing; it revolutionizes how teams approach quality assurance.
          </p>
        </div>
      </section>

  );
}
